var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:[
    'asc-surface--title',
    _vm.upperCase ? 'asc-surface--title-upperCase' : '' ]},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }